var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2 pr-4"},[_c('v-expand-transition',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}],staticClass:"mb-0 show-line-breaks"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }